import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function HeroSection() {
  return <section className="w-full px-6 pt-10 pb-8 md:pt-16 md:pb-10" data-id="element-143">
      <div className="max-w-2xl mx-auto" data-id="element-144">
        <AnimatedSection data-id="element-145">
          <p className="text-warm-gray text-sm tracking-widest uppercase mb-5 font-medium" data-id="element-146">
            Para cuando no puedes ni empezar
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.1} data-id="element-147">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-charcoal leading-tight mb-5" data-id="element-148">
            Tu casa no necesita
            <br data-id="element-149" />
            <span className="italic text-teal" data-id="element-150">"organización".</span>
            <br data-id="element-151" />
            Necesita un <span className="text-teal" data-id="element-152">RESET.</span>
          </h1>
        </AnimatedSection>

        <AnimatedSection delay={0.2} data-id="element-153">
          <p className="text-lg md:text-xl text-warm-gray leading-relaxed mb-4 font-serif italic" data-id="element-154">
            48 horas para volver a caminar sin esquivar cosas.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-155">
          <div className="space-y-3 text-charcoal/80 text-base md:text-lg leading-relaxed mb-8" data-id="element-156">
            <p data-id="element-157">Hay un tipo de cansancio que no se arregla con dormir.</p>
            <p data-id="element-158">
              Es el cansancio de mirar tu casa y sentir que te está mirando de
              vuelta.
            </p>
            <p className="text-charcoal/60" data-id="element-159">La pila en la esquina.</p>
            <p className="text-charcoal/60" data-id="element-160">La cocina que te da rabia.</p>
            <p className="text-charcoal/60" data-id="element-161">
              La ropa que no es ropa: es una prueba de que "no te está
              alcanzando".
            </p>
            <p data-id="element-162">Y lo peor no es el desorden.</p>
            <p data-id="element-163">
              Lo peor es esa frase silenciosa que se te cuela cuando apagas la
              luz:
            </p>
            <p className="font-serif text-xl md:text-2xl text-charcoal italic pl-4 border-l-2 border-sand" data-id="element-164">
              "¿Cómo dejé que llegara a esto?"
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.35} data-id="element-165">
          <div className="bg-teal-light/50 rounded-2xl p-5 md:p-6 mb-8" data-id="element-166">
            <p className="text-charcoal/90 text-base md:text-lg leading-relaxed" data-id="element-167">
              Este no es otro PDF de "hábitos" que dura tres días.
            </p>
            <p className="text-charcoal font-medium text-base md:text-lg leading-relaxed mt-3" data-id="element-168">
              Esto es un protocolo para cuando estás agotada: un orden exacto
              para recuperar una casa caminable en 48 horas…{' '}
              <span className="text-teal font-semibold" data-id="element-169">
                sin motivación y sin perfección.
              </span>
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.4} data-id="element-170">
          <div className="flex justify-center mb-3" data-id="element-171">
            <img src="https://cdn.magicpatterns.com/uploads/a7edDFiq4xcsk9ihP7Saue/mock_up_48_hrs.png" alt="RESET 48: Casa Caminable en 2 Días — mockup del PDF en una tablet" className="w-full max-w-md rounded-xl shadow-lg" data-id="element-172" />
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.45} data-id="element-173">
          <div className="flex justify-center" data-id="element-174">
            <a href="#precio" className="inline-block bg-teal text-white font-semibold text-lg px-10 py-4 rounded-full transition-transform duration-200 hover:scale-105 hover:bg-teal-dark focus:outline-none focus:ring-2 focus:ring-teal focus:ring-offset-2 focus:ring-offset-cream" role="button" data-id="element-175">
              Quiero mi RESET 48 →
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}